const BUSINESS_LOCALE = 'en-UG';
const BUSINESS_TIME_ZONE = 'Africa/Kampala';

const toDate = (value) => {
  if (!value) return null;
  const parsed = value instanceof Date ? value : new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const formatBusinessDate = (value, options = {}) => {
  const parsed = toDate(value);
  if (!parsed) return value || '-';

  return new Intl.DateTimeFormat(BUSINESS_LOCALE, {
    timeZone: BUSINESS_TIME_ZONE,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...options,
  }).format(parsed);
};

export const formatBusinessDateTime = (value, options = {}) => {
  const parsed = toDate(value);
  if (!parsed) return value || '-';

  return new Intl.DateTimeFormat(BUSINESS_LOCALE, {
    timeZone: BUSINESS_TIME_ZONE,
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    ...options,
  }).format(parsed);
};

export const formatBusinessTime = (value = new Date(), options = {}) =>
  formatBusinessDateTime(value, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    ...options,
  });

export const formatBusinessWeekdayDate = (value = new Date(), options = {}) =>
  formatBusinessDate(value, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    ...options,
  });

export const BUSINESS_TIME_ZONE_LABEL = BUSINESS_TIME_ZONE;
